import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { isArray, isEmpty } from 'lodash';

import moment from 'moment';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Input, DateTime } from '~/components/Form';

import { t } from '~/helpers';
import api from '~/services/api';

import { FormWrapper } from './styles';

import * as S from './styles';

export default function MyForm({ data, reference, close, cancelarAcao }) {

  async function handleSubmit(param) {
    try {

      let fatu_data_faturadate = moment(data.fatu_data_fatura).format("YYYY/MM/DD");
                
      let fatu_data_pagamentodate = moment(param.fatu_data_pagamento ,"DD/MM/YYYY").format("YYYY/MM/DD");
      
      let sparam = {
        ...param,
        fatu_data_pagamento : fatu_data_pagamentodate,        
      }     

      

      const schema = Yup.object().shape({
        fatu_data_pagamento: Yup.date()
          .typeError('Data invalida')     
          .nullable('Data invalida')
          .min(new Date(fatu_data_faturadate), `Data invalida, deve ser maior que ${moment(fatu_data_faturadate, 'YYYY/MM/DD', true).format('DD/MM/YYYY')} `)
          .max(new Date(), `Data invalida, deve ser menor que ${ moment(new Date(), 'YYYY-MM-DD HH:mm:ss', true).format('DD/MM/YYYY') } `)        
          .required(t('s.geral.validacao.campoobrigatorio')         
        ),
      });

      await schema.validate(sparam, {
        abortEarly: false,
      });

      const objSend = {
        fatu_codigo: param.fatu_codigo,
        fatu_data_pagamento: moment(param.fatu_data_pagamento, 'DD/MM/YYYY HH:mm:ss', true).format('DD/MM/YYYY') , 
        fatu_data_fatura: moment(data.fatu_data_fatura).format('DD/MM/YYYY') , 

        //fatu_data_pagamento: param.fatu_data_pagamento,
      };

      await api.put('radadmdadosfaturamentounidata/incluirpagamentonotafiscalfatura', objSend);
      toast.success(t('s.geral.sucessoalteracao'));

      await close();
    } catch (err) {
      await cancelarAcao();

      if (isArray(err)) {
        err.map((e) => toast.error(e));
      }

      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    reference.current.setData(data);
  }, []);

  return (
    <>

      <S.Wrapper>

        <FormWrapper ref={reference} initialData={data} onSubmit={handleSubmit}>

          <Input
            name="fatu_codigo"
            label="Número da Pré-Fatura:"
            disabled
          />

          <Input
            name="fatu_numero_pedido"
            label="Número do Pedido:"
            disabled
          />

          <Input
            name="fatu_nota_fiscal"
            label="Nota Fiscal:"
            disabled
          />

          <Input
            name="orga_nome"
            label="Órgão:"
            disabled
          />


          <DateTime
            nullable
            name="fatu_data_pagamento"
            label='Pago Em:'
            disablePast={false}
            disableFuture={true}
            minDateMessage=""
            maxDateMessage=""
            invalidDateMessage={''}
            minDate={data.fatu_data_fatura}
            serialize={(value) =>
              value.set({ seconds: 0 }).format('DD/MM/YYYY HH:mm:ss')
            }
          />

        </FormWrapper>
      </S.Wrapper>
    </>
  );
}

MyForm.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  close: PropTypes.func.isRequired,
  cancelarAcao: PropTypes.func.isRequired,
};
